<template>
  <div>
    <vs-prompt
      :title="isNew ? 'Add storage' : 'Update storage'"
      @cancel="val = ''"
      @accept="accept"
      @close="close"
      :active.sync="prompt"
      :accept-text="isNew ? 'Add' : 'Update'"
      :is-valid="validForm"
      class=""
    >
      <vs-row>
        <vs-col vs-w="12">
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Name</span>
            </div>
            <div class="vx-col sm:w-4/5 w-full">
              <vs-input v-model="name" />
            </div>
          </div>
        </vs-col>
      </vs-row>
    </vs-prompt>
  </div>
</template>


<script>
import { mapGetters } from "vuex";
export default {
  components: {},
  data() {
    return {
      existingId: null,
      name: "",
      prompt: false,
    };
  },
  computed: {
    ...mapGetters({
      venue: "pos/venues/venue",
    }),
    isNew() {
      return !this.existingId;
    },
    validForm() {
      return this.name && this.name.length > 0;
    },
  },
  methods: {
    show(withStorage) {
      this.name = "";
      this.existingId = null;

      if (withStorage) {
        this.existingId = withStorage.storageId.id;
        this.name = withStorage.name;
      }
      this.prompt = true;
    },
    async accept() {
      this.$vs.loading();

      if (this.isNew) {
        await this.$store.dispatch("pos/venues/createStorage", {
          venueId: this.venue.id,
          storageName: this.name,
        });
      } else {
        await this.$store.dispatch("pos/venues/updateStorage", {
          venueId: this.venue.id,
          storageId: this.existingId,
          storageName: this.name,
        });
      }

      this.$vs.notify({
        color: "success",
        title: `Venue updated`,
        text: "Venue updated",
      });
      this.$vs.loading.close();
    },
    close() {},
  },
};
</script>

<style lang="scss" scoped>
</style>
